<template>
  <content-loader :height="240">
    <!--		Sidebar-->
    <rect x="0" y="0" rx="3" ry="3" width="130" height="130" />
    <rect x="5" y="140" rx="0" ry="0" width="90" height="10" />
    <rect x="0" y="160" rx="0" ry="0" width="100" height="25" />
    <rect x="5" y="200" rx="0" ry="0" width="70" height="8" />
    <rect x="5" y="220" rx="0" ry="0" width="40" height="8" />
    <!--		Main content-->
    <rect x="150" y="10" rx="0" ry="0" width="140" height="10" />

    <rect x="150" y="30" rx="0" ry="0" width="100" height="20" />
    <rect x="260" y="30" rx="0" ry="0" width="170" height="20" />
    <rect x="440" y="30" rx="0" ry="0" width="60" height="20" />

    <rect x="150" y="60" rx="0" ry="0" width="240" height="20" />
    <rect x="400" y="60" rx="0" ry="0" width="100" height="20" />

    <rect x="150" y="90" rx="0" ry="0" width="240" height="20" />
    <rect x="400" y="90" rx="0" ry="0" width="100" height="20" />

    <rect x="150" y="140" rx="0" ry="0" width="140" height="10" />
    <rect x="150" y="160" rx="0" ry="0" width="350" height="15" />
    <rect x="150" y="190" rx="0" ry="0" width="120" height="8" />
  </content-loader>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
